import { jsx } from "react/jsx-runtime";
import { Button } from "@nxt-costco-com/forge-components";
import { Analytics } from "../../../Analytics/index.js";
import { DEFAULT_BUTTON_TEXT_COLOR, DEFAULT_BUTTON_BACKGROUND_COLOR } from "../constants.js";
import { generateStyles } from "../utils.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
function CallToActionButton({
  buttonBlock
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  if (!buttonBlock || !((_a = buttonBlock == null ? void 0 : buttonBlock.button_url) == null ? void 0 : _a.title)) {
    return null;
  }
  return /* @__PURE__ */ jsx(CostcoBox, { sx: { margin: "8px 0", width: "100%" }, children: /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: {
        adItem: {
          isExternal: (_b = buttonBlock == null ? void 0 : buttonBlock.button_url) == null ? void 0 : _b.external_site,
          url: (_c = buttonBlock == null ? void 0 : buttonBlock.button_url) == null ? void 0 : _c.url
        },
        title: buttonBlock == null ? void 0 : buttonBlock.button_url.title
      },
      children: /* @__PURE__ */ jsx(
        Button,
        {
          "aria-label": buttonBlock == null ? void 0 : buttonBlock.link_aria_label,
          sx: {
            "&:hover": {
              background: generateStyles(
                (buttonBlock == null ? void 0 : buttonBlock.font_and_button_color) || DEFAULT_BUTTON_BACKGROUND_COLOR
              ),
              color: ((_e = (_d = buttonBlock == null ? void 0 : buttonBlock.font_and_button_color) == null ? void 0 : _d.text_color) == null ? void 0 : _e.hex) || DEFAULT_BUTTON_TEXT_COLOR
            },
            background: generateStyles(
              buttonBlock == null ? void 0 : buttonBlock.font_and_button_color
            ) || DEFAULT_BUTTON_BACKGROUND_COLOR,
            color: ((_g = (_f = buttonBlock == null ? void 0 : buttonBlock.font_and_button_color) == null ? void 0 : _f.text_color) == null ? void 0 : _g.hex) || DEFAULT_BUTTON_TEXT_COLOR,
            height: "fit-content",
            width: "100%"
          },
          href: (_h = buttonBlock == null ? void 0 : buttonBlock.button_url) == null ? void 0 : _h.url,
          children: buttonBlock == null ? void 0 : buttonBlock.button_url.title
        }
      )
    }
  ) });
}
export {
  CallToActionButton
};
